import styled, { css } from 'styled-components'
import {
    marginProps,
    paddingProps,
    borderRadiusProps,
} from '@/ui/SpacingUtility'

export const flexProps = (props) => css`
    ${props.color && `color: ${props.color}`};
    ${props.background && `background: ${props.background}`};
    ${props.width && `width: ${props.width}`};
    ${props.height && `height: ${props.height}`};
`

const Flex = styled.div`
    display: flex;
    ${marginProps};
    ${paddingProps};
    ${borderRadiusProps};
    ${flexProps};
    flex-flow: ${(props) => (props.direction ? props.direction : 'row')};
    justify-content: ${(props) => (props.justify ? props.justify : 'center')};
    align-items: ${(props) => (props.align ? props.align : 'center')};
    flex: ${(props) => (props.flex ? props.flex : '1 1 auto')};
    font-size: ${(props) => (props.fontSize ? props.fontSize : 'inherit')};
    cursor: ${(props) => (props.cursor ? props.cursor : 'auto')};
    width: ${(props) => (props.width ? props.width : 'auto')};
    height: ${(props) => (props.height ? props.height : 'auto')};
    gap: ${(props) => (props.gap ? props.gap : 'unset')};
    box-shadow: ${(props) => (props.boxShadow ? props.boxShadow : 'none')};
    flex-direction: ${(props) =>
        props.flexDirection ? props.flexDirection : 'row'};
`

export default Flex
